import React from "react";

import { makeStyles } from "tss-react/mui";

import ratingFlagIcon from "@assets/icons/rating-flag.svg";
import ratingHeartIcon from "@assets/icons/rating-heart.svg";
import ratingMehIcon from "@assets/icons/rating-meh.svg";
import ratingThinkIcon from "@assets/icons/rating-think.svg";
import ratingThumbsIcon from "@assets/icons/rating-thumbs.svg";

const useStyles = makeStyles()({
  icon: {
    width: 42,
    height: 42,
    objectFit: "contain",
  },
});

interface Props {
  className?: string;
  rating: number | null | undefined;
}

const MealRatingIcon: React.FC<Props> = ({ className, rating }) => {
  const { classes, cx } = useStyles();
  switch (rating) {
    case 1:
      return (
        <img className={cx(classes.icon, className)} src={ratingFlagIcon} />
      );
    case 2:
      return (
        <img className={cx(classes.icon, className)} src={ratingMehIcon} />
      );
    case 3:
      return (
        <img className={cx(classes.icon, className)} src={ratingThinkIcon} />
      );
    case 4:
      return (
        <img className={cx(classes.icon, className)} src={ratingThumbsIcon} />
      );
    case 5:
      return (
        <img className={cx(classes.icon, className)} src={ratingHeartIcon} />
      );
    default:
      return <span>-</span>;
  }
};

export default MealRatingIcon;
